import React, { Component } from "react";
import Column from "../components/kanban/columns/Column";
// import NewColumn from "../components/kanban/columns/NewColumn";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
// import { getBoundingClientRect } from '../utils/functions'
// import NewColumnItem from "../components/kanban/columns/NewColumnItem";
import { checkTranslation, getObject, paramsToValue, setObject, translate } from "../utils/useful";
import { nanoid } from "nanoid";
// import { Modal } from "react-bootstrap";
// import HttpServices from "../utils/Http.services";

class Kanban extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newTask: false,
            columns: [],
            viwe: true,
            showCol: true,
        };
        this.colHolderRef = React.createRef();
    }
    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps, prevState) {
        // if (JSON.stringify(prevProps.data) != JSON.stringify(this.props.data)) {

        //     if (this.props.stackedKey) {
        //         let keys = [this.props.stackedKey]
        //         this.groupBy(0, this.props.data, keys, () => {
        //             this.setState({ showCol: false }, () => {
        //                 this.setState({ showCol: true })
        //             })
        //         })
        //     }
        // }


        if (prevProps.stackedKey != this.props.stackedKey) {
            if (this.props.stackedKey) {

                console.log("HEREEEEE")
                console.log(this.props.stackedKey)

                let stackedKey = typeof this.props.stackedKey == 'object' ? this.props.stackedKey?.stackedField : this.props.stackedKey

                let keys = [stackedKey]
                this.groupBy(0, this.props.data, keys, () => {
                    this.setState({ showCol: false }, () => {
                        this.setState({ showCol: true })
                    })
                })
            }
        }
        else if (JSON.stringify(this.props.data) != JSON.stringify(prevProps.data)) {
            let keys = [this.props.view?.settings?.stacked?.stackedField]
            this.groupBy(0, this.props.data, keys, () => {
                this.setState({ showCol: false }, () => {
                    this.setState({ showCol: true })
                })
            })
        }

        if (this.props.headers != prevProps.headers) {
            this.init()
        }

    }


    init() {
        let stackedField = this.props.view?.settings?.stacked?.stackedField
        if (stackedField) {
            // console.log("this.props.headers!!,", this.props.headers)
            // console.log(stackedField)

            let key = paramsToValue(null, stackedField, this.props.headers, 'Current Record', true)
            // console.log(key)
            let keys = [key]

            // console.log(keys)
            // ['values.SdlkDrq7qvqxYO7Jbedtp', 'values.7hFuEW19W58MjP1EDiEHd']
            setTimeout(() => {
                // console.log('view121212', keys)
                this.groupBy(0, this.props.data, keys)
                if (this.props.view?.settings?.stacked) {
                    // this.props.openSelectStack()
                }
            }, 100)
        }

    }

    groupBy = (keyIndex = 0, data = this.state.data, keys, cb) => {
        // console.log("======= groupBy =========")
        // console.log(keys)

        this.setState({ dataGroup: {}, columns: [] }, () => {


            if (keys && keys.length > 0) {
                if (keyIndex == 0) {
                    this.setState({ orgData: this.props.data })
                }

                let group = {}
                let headers = this.props.headers

                if (data) {

                    let key = keys[keyIndex]
                    let header
                    headers?.forEach(element => {
                        if (key == element.key) {
                            header = element
                        }
                    });

                    // console.log("RawData, ", data)

                    if (Array.isArray(data) && header) {
                        data.forEach(element => {
                            let info = getObject(element, key)
                            // console.log('elementingo is', element)
                            // console.log('header', header)
                            // console.log('info00000', info)
                            // console.log('header.type', header.type)

                            if (Array.isArray(info)) {
                                info = info[info.length - 1]
                            }
                            // console.log("info, ", info)
                            let groupKey = info ? (typeof info == 'object' ? String(info._id) : String(info)) : '*undefinded'

                            if (header.type == 'SelectInput' && Array.isArray(header.information?.items)) {
                                header.information.items.forEach(ielement => {
                                    if (ielement.value == groupKey) {
                                        info = ielement
                                    }
                                })
                            }

                            if (!group[groupKey]) {
                                // console.log('info', info)
                                group[groupKey] = { id: nanoid(), header, key: groupKey, fullData: element, info: info, data: [], }
                            }
                            group[groupKey].data.push(element)

                        })
                    }

                    if (header) {

                        if (header.type == 'SelectInput' && Array.isArray(header.information?.items)) {

                            header.information.items.forEach(ielement => {
                                if (!group[ielement.value]) {
                                    group[ielement.value] = { id: nanoid(), header, key: ielement.value, info: ielement, data: [], }
                                }
                            })

                        }

                        if (keyIndex != keys.length - 1) {
                            for (const [groupKey, groupValues] of Object.entries(group)) {
                                group[groupKey] = { header, id: nanoid(), data: this.groupBy(keyIndex + 1, groupValues.data, keys) }
                            }
                        }

                        if (keyIndex == 0) {
                            this.setState({ dataGroup: group }, () => {
                                // console.log('dataGroup', this.state.dataGroup)
                            })
                        }
                    }
                    this.kanbanMaker(group, cb)

                    return group

                }
            }
        })
    }

    kanbanMaker = (groups, cb) => {
        // console.log('col=====', groups)

        let groupsInfo = Object.entries(groups)
        let columns = []
        groupsInfo.forEach(group => {
            let col = {}
            let item = typeof group[1]?.info == 'object' ? group[1].info : { title: group[1].info } //{ textTitleunAssigned: 'UnAssigned', textColorunAssigned: "#000", backColorunAssigned: "#d3d3d3", id: "unAssigned" }
            // console.log('itemColumn', item)
            // console.log(group)
            if (group[0] != "undefined" && item) {
                // console.log(item)
                if (item?.id == null && group[1]?.id) {
                    item.id = group[1]?.id
                }


                if (item.id == null && item.value) {
                    item.id = item.value
                }

                if (item.id == null && item._id) {
                    item.id = item._id
                }

                if (item.id == null && item.title) {
                    item.id = item.title
                }

                // if (group[1].header?.type == 'GlobalUserInput') {
                //     this.setState({ isLoadingUser: true })
                //     HttpServices.request('getOneUserLimitedInfo', { id: group[0] }, async (res, er) => {

                //         if (!er && res) { item.textTitleunAssigned = await res.info?.fullname; col.columnHeader = await res.info?.fullname; this.setState({ isLoadingUser: false }) }
                //     })
                // }
                // console.log('column=====', col)


            } else {
                item = { title: '{{lang}}Undefined', id: "*undefined" }

            }

            // item.type = 

            // console.log("GROUP, ",group)
            // console.log('group', group[1].fullData)
            item.headerKey = group[1].header?.key
            col.columnHeader = item['title']
            col.headerInfo = item

            col.fullData = group[1].fullData
            col.headerInfo.type = group[1].header.type
            col.headerInfo.information = group[1].header.information

            // let items = group[1].header?.information?.items ?? []
            // items?.forEach(item => {

            //     console.log(item)
            //     if (item.id == group[0]) {
            //         col.columnHeader = item['textTitle' + group[0]]
            //         col.headerInfo = item
            //     }
            // })
            col.columnid = item.id
            col.columnList = []
            group[1].data.forEach(i => {
                let dataOne = { itemId: i?._id, form: { values: i?.values }, data: i, taskName: i?.name }
                col.columnList.push(dataOne)
            })
            // console.log('wqdwqds', col)
            columns.push(col)

        })

        // console.log("columns, ", columns)
        this.setState({ columns }, () => {
            if (cb) {
                cb()
            }
        })
    }


    addNewItem = (columnId, data, nameKey) => {
        const { columns } = this.state;
        let oldColumns = [...columns];
        let newItem = { itemId: uuidv4(), form: data.form, taskName: data[nameKey] };
        oldColumns.find((col) => col.columnid == columnId).columnList.push(newItem);
        this.setState({ columns: oldColumns }, () => {
        });
    };

    addNewColumn = (inputValue) => {
        const { columns } = this.state;
        let oldColumns = [...columns];
        let newColumn = {
            columnid: uuidv4(),
            columnHeader: inputValue,
            columnList: []
        };
        oldColumns.push(newColumn);
        this.setState({ columns: oldColumns });
    };

    removeNewColumn = (inputValue) => {
        const { columns } = this.state;
        let oldColumns = [...columns];
        let newColumn = {
            columnid: uuidv4(),
            columnHeader: inputValue,
            columnList: []
        };
        oldColumns.pop(newColumn);
        this.setState({ columns: oldColumns });
    };

    onRenameItem = (newName) => {
        // console.log("renameeeeeee")
        const { columns, currentIndex } = this.state;
        let oldColumns = [...columns];
        oldColumns[currentIndex].columnHeader = newName;
        this.setState({ columns: oldColumns });
    }

    onDragEnd = (result) => {

        const { source, destination, draggableId, type } = result;

        // console.log(source, destination, draggableId, type)
        // console.log(this.state.dataGroup)

        if (!destination) {
            let { columns } = this.state;
            let oldColumns = [...columns];
            let lastIndex = oldColumns.length;
            let toReplaceCol = oldColumns[source.index];
            oldColumns.splice(source.index, 1);
            oldColumns.splice(lastIndex, 0, toReplaceCol);
            this.setState({ columns: oldColumns });
        }

        if (
            destination &&
            source &&
            destination.droppableId === source.droppableId &&
            destination.index == source.index
        ) {
            return;
        }

        if (destination && source && type == "column") {
            let { columns } = this.state;
            let oldColumns = [...columns];
            let toReplaceCol = oldColumns[source.index];
            oldColumns.splice(source.index, 1);
            oldColumns.splice(destination.index, 0, toReplaceCol);
            this.setState({ columns: oldColumns });
        } else if (destination && source && type !== "column") {
            let { columns } = this.state;
            // console.log(columns)

            let oldColumns = [...columns];
            let toRemoveCol = oldColumns.find(
                (col) => col.columnid == source.droppableId
            );
            let toAddCol = oldColumns.find(
                (col) => col.columnid == destination.droppableId
            );
            let toReplaceItem = toRemoveCol.columnList[source.index];
            toRemoveCol.columnList.splice(source.index, 1);
            toAddCol.columnList.splice(destination.index, 0, toReplaceItem);

            // console.log(toReplaceItem);
            // console.log(toAddCol);

            // console.log(toAddCol.headerInfo?.headerKey,toAddCol.columnHeader);

            setObject(toReplaceItem.data, toAddCol.headerInfo?.headerKey, toAddCol.columnHeader)
            setObject(toReplaceItem.form, toAddCol.headerInfo?.headerKey, toAddCol.columnHeader)

            // console.log(toReplaceItem);

            this.props.submitForm(toReplaceItem.data, true)

            this.setState({ columns: oldColumns });
        }
    }

    setNewTask = () => {
        this.setState({ newTask: !this.state.newTask });
    }
    removeNewSubColumn = (iId, cId) => {
        let columns = this.state.columns;
        columns = columns.find((col) => col.columnid == cId).columnList.filter(i => i.itemId != iId)
        // console.log('afterdel==', columns)
        this.setState({ columns });
    }
    // openStackModal = () => {
    //     console.log('openSelectStack')
    //     this.props.openSelectStack()
    // }

    openSelectStack = () => {
        if (this.props.openSelectStack) {
            this.props.openSelectStack()
        } else {
            console.log(this.props.functionsHandler)

            if (this.props.functionsHandler) {
                this.props.functionsHandler(null, 'showConfig')
            }
        }
    }


    render() {
        const { newTask, columns } = this.state;

        // console.log(this.props.headers)
        return (
            <div className="kanban-spaceItem sc-2 w-100 h-100 " style={{ display: "flex", alignItems: "flex-start", background: this.props.background ?? '#f8f8f8' }}>
                {/* {console.log('this.props.view?.settings', this.props.view?.settings)} */}
                {this.props.view?.settings?.stacked?.stackedField ? (
                    <div className="w-100 h-100 d-flex" >
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="sll-columns" direction="horizontal" type="column">
                                {(provided, snapshot) => (
                                    <div className="columns-holder w-100 h-100 sc-3 prd-4" style={{ overflow: 'auto' }}
                                        // style={{ width: 300 * columns.length, minWidth: 300 * columns.length, }}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >

                                        {/* {console.log('columns',columns)} */}
                                        {this.state.showCol && columns.map((column, index) => {
                                            const { columnList, columnHeader, columnid, headerInfo, fullData } = column;
                                            return (
                                                <Column
                                                    column={column}
                                                    key={columnid}
                                                    columnid={columnid}
                                                    columnHeader={columnHeader}
                                                    fullData={fullData}
                                                    newTask={newTask}
                                                    setNewTask={this.setNewTask}
                                                    onRenameItem={this.onRenameItem}
                                                    removeNewColumn={this.removeNewColumn}
                                                    columnList={columnList}
                                                    columnItemsLength={columnList?.length}
                                                    addNewItem={this.addNewItem}
                                                    addNewColumn={this.addNewColumn}
                                                    index={index}
                                                    headers={this.props.headers}
                                                    width={this.props.width}
                                                    removeNewSubColumn={(e) => this.removeNewSubColumn(e, columnid)}
                                                    actions={this.props.actions}
                                                    page={this.props.page}

                                                    headerInfo={headerInfo}
                                                    functionsHandler={this.props.functionsHandler}
                                                    view={this.props.view}

                                                />
                                            );
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                            {/* <div className="w-100">
                        <NewColumn addNewColumn={this.addNewColumn} />
                    </div> */}
                        </DragDropContext>
                    </div>
                ) : (
                    <div className="flexcc w-100">
                        <div className=" pt-5 pb-5 px-3 flexcc flex-column text-center" >
                            <p className="py-1 text-bold text-big">{translate("Needs configuration")}</p>
                            <p className="py-1 text-small" style={{ maxWidth: 500 }}>{translate("For using boards view, you need to do a configuration on the fields, use the botton below to do this configuration")}</p>

                            <button className="p-2 px-4 br-30  mt-2 text-semibold" onClick={() => this.openSelectStack()} style={{ background: '#007aff', color: '#fff' }} >
                                <p>{translate("Open Config")}</p>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Kanban;
// import React, { useRef, useState } from "react";
// import Column from "../components/kanban/columns/Column";
// import NewColumn from "../components/kanban/columns/NewColumn";
// import { DragDropContext, Droppable } from "react-beautiful-dnd";
// import { v4 as uuidv4 } from "uuid";
// import { getBoundingClientRect } from '../utils/functions'
// import NewColumnItem from "../components/kanban/columns/NewColumnItem";

// const Kanban = () => {
//     const [newTask, setNewTask] = useState(false);
//     // const [like, setlike] = useState(false);

//     const colHolderRef = useRef();
//     const [columns, setColumns] = useState([]);
//     const addNewItem = (columnId, inputValue) => {
//         let oldColumns = [...columns];
//         let newItem = { itemId: uuidv4(), itemName: inputValue };
//         oldColumns
//             .find((col) => col.columnid == columnId)
//             .columnList.push(newItem);
//         setColumns(oldColumns);
//     };
//     const addNewColumn = (inputValue) => {
//         let oldColumns = [...columns];
//         let newColumn = {
//             columnid: uuidv4(),
//             columnHeader: inputValue,
//             columnList: []
//         };
//         oldColumns.push(newColumn);
//         setColumns(oldColumns);
//     };
//     const removeNewColumn = (inputValue) => {
//         let oldColumns = [...columns];
//         let newColumn = {
//             columnid: uuidv4(),
//             columnHeader: inputValue,
//             columnList: []
//         };
//         oldColumns.pop(newColumn);
//         setColumns(oldColumns);
//     };
//     const onRenameItem = (newName) => {
//         console.log("renameeeeeee")
//         let oldColumns = [...columns];
//         oldColumns[this.state.currentIndex].columnHeader = newName
//         // let newColumn = {
//         //     columnid: uuidv4(),
//         //     columnHeader: newName,
//         //     columnList: []
//         // };
//         // oldColumns.push(newColumn);
//         setColumns(oldColumns);
//     }
//     function onDragEnd(result) {
//         const { source, destination, draggableId, type } = result;
//         // console.log(result);
//         //   // dropped outside the list

//         if (!destination) {
//             // console.log(1);
//             let oldColumns = [...columns];
//             let lastIndex = oldColumns.length;
//             let toReplaceCol = oldColumns[source.index];
//             oldColumns.splice(source.index, 1);
//             oldColumns.splice(lastIndex, 0, toReplaceCol);
//             setColumns(oldColumns);
//         }

//         if (
//             destination &&
//             source &&
//             destination.droppableId === source.droppableId &&
//             destination.index == source.index
//         ) {
//             // console.log(2);
//             return;
//         }

//         if (destination && source && type == "column") {
//             // console.log(3);
//             let oldColumns = [...columns];
//             let toReplaceCol = oldColumns[source.index];
//             oldColumns.splice(source.index, 1);
//             oldColumns.splice(destination.index, 0, toReplaceCol);
//             setColumns(oldColumns);
//         } else if (destination && source && type !== "column") {
//             // console.log(4);
//             // console.log(columns);

//             let oldColumns = [...columns];
//             let toRemoveCol = oldColumns.find(
//                 (col) => col.columnid == source.droppableId
//             );
//             let toAddCol = oldColumns.find(
//                 (col) => col.columnid == destination.droppableId
//             );
//             let toReplaceItem = toRemoveCol.columnList[source.index];
//             console.log(toReplaceItem);
//             toRemoveCol.columnList.splice(source.index, 1);
//             toAddCol.columnList.splice(destination.index, 0, toReplaceItem);
//             setColumns(oldColumns);
//         }
//     }

//     return (
//         <div className="kanban-spaceItem sc-2 w-100" style={{ display: "flex", alignItems: "flex-start", paddingLeft: " 1rem", paddingRight: " 1rem", overflowX: "scroll" }}>

//             <DragDropContext onDragEnd={onDragEnd}>
//                 <Droppable droppableId="sll-columns" direction="horizontal" type="column">
//                     {(provided, snapshot) => (
//                         <div className="columns-holder"
//                             sstyle={{ width: 300 * columns.length, minWidth: 300 * columns.length, }}
//                             ref={provided.innerRef}
//                             {...provided.draggableProps}
//                             {...provided.dragHandleProps}
//                         >
//                             {columns.map((column, index) => {

//                                 const { columnList, columnHeader, columnid } = column;
//                                 return (
//                                     <Column
//                                         key={columnid}
//                                         columnid={columnid}
//                                         columnHeader={columnHeader}
//                                         newTask={newTask}
//                                         setNewTask={setNewTask}
//                                         // like={like}
//                                         // addTofavorite={addTofavorite}
//                                         onRenameItem={onRenameItem}
//                                         removeNewColumn={removeNewColumn}
//                                         columnList={columnList}
//                                         columnItemsLength={columnList.length}
//                                         addNewItem={addNewItem}
//                                         addNewColumn={addNewColumn}
//                                         index={index}
//                                     />
//                                 );
//                             })}
//                             {provided.placeholder}
//                         </div>
//                     )}
//                 </Droppable>
//                 <div className="w-100">
//                     <NewColumn addNewColumn={addNewColumn} />
//                 </div>
//             </DragDropContext>

//         </div>
//     );
// };

// export default Kanban;


